import { call, put } from 'redux-saga/effects'
import { sync } from './concern/helpers'
import firebase from '../config/firebase'

import FreeCheckoutActions, { FreeCheckoutTypes } from '../reducers/freeCheckoutReducer'

export function* syncFreeCheckoutPromotions() {
  yield call(sync, {
    ref: firebase.firestore().collection('free_checkout_promotions'),
    unSync: FreeCheckoutTypes.UN_SYNC_FREE_CHECKOUT_PROMOTIONS,
    onError: () => put(FreeCheckoutActions.setFreeCheckoutPromotions({})),
    onChange: data => put(FreeCheckoutActions.setFreeCheckoutPromotions(data)),
  })
}



// WEBPACK FOOTER //
// ./src/sagas/freeCheckoutSaga.js